module.exports = __webpack_public_path__ + "img/stromquelle LP.77c61ee1.png";